export enum BreackpointsX {
  LAPTOP = 1366,
  TABLET = 768,
  MOBILE_SM = 400,
}

export enum BreackpointsY {
  LG = 768,
  MD = 667,
  SM = 400,
}
